import { styled } from "goober";

export const SettingsModalContent = styled("div")`
  display: flex;
  flex-direction: column;
  width: 448px;
  height: 600px;
`;

export const SettingsModalHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
`;

export const HeaderIconContainer = styled("div")`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--alpha4);
  border-radius: 8px;
  flex-shrink: 0;
`;

export const HeaderRight = styled("div")`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const SettingsModalBody = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  padding: 16px;
  overflow-y: auto;
  border-top: 0.5px solid var(--border-alpha);
`;

export const SettingsModalFooter = styled("div")`
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 0.5px solid var(--border-alpha);
`;

export const Section = styled("div")`
  &:not(:first-child) {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 0.5px solid var(--border-alpha);
  }
`;

export const SectionHeader = styled("div")`
  display: flex;
  align-items: center;
  padding: 0 8px 8px;
`;

export const ListRow = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
`;

export const ListRowRemoveButton = styled("button")`
  all: unset;
  margin-left: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  ${ListRow}:hover & {
    opacity: 0.5;
  }
  &:hover {
    opacity: 1 !important;
  }
`;

export const EmptyState = styled("div")`
  padding: 8px;
  opacity: 0.4;
`;
